export default class InquiriesForm {
  constructor(el) {
    this.el = el;
    this.initialize();
  }

  initialize() {
    new Vue({
      el: this.el,
      name: 'InquiriesForm',
      data() {
        return {
          isLoading: false,
          inquiry: {
            agree: false,
            email: '',
            subject: '',
            kind: '',
            contents: '',
          },
          validated: false,
        };
      },
      mounted() {
        this.inquiry = Object.assign(this.inquiry, JSON.parse(this.$el.getAttribute('data-default-inquiry')));
      },
      methods: {
        async handleSubmit(event) {
          this.isLoading = true;
          const valid = await this.validateAgree();
          if (!valid) {
            this.isLoading = false;
            event.preventDefault();
          }
        },
        async validateAgree() {
          this.validated = true;
          return this.inquiry.agree;
        },
      },
    });
  }
}
